import type { MembershipProduct } from "../../platform_spaces/space/SpaceType";

/** 零售订阅按钮与购买弹窗共用的可购状态 */
export function membershipRetailPurchaseState(row: MembershipProduct) {
  const isStrategyTool = row.productKind === "strategy_tool";
  const isMarket = isStrategyTool && row.strategySaleMode === "market";
  const isRetail = row.pricingMode?.trim().toLowerCase() === "retail";
  const specs = isRetail ? row.priceSpecs ?? [] : [];
  const canBuyMore =
    isRetail &&
    (isMarket
      ? (row.strategySkuOffers ?? []).some((o) =>
          (o.priceSpecs ?? []).some((s) => s.enabled)
        )
      : specs.some((s) => s.enabled));
  const canBuyRetail = !row.userSubscribed && canBuyMore;
  return { isStrategyTool, isMarket, isRetail, specs, canBuyMore, canBuyRetail };
}
